// extracted by mini-css-extract-plugin
export default {"item":"channel-item_item__7Dlr8","text":"channel-item_text__kljXK","icon":"channel-item_icon__cCPdj"};